import { set } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import { fetchInventoryAvailabilityOptions } from '../../../sagas/routines';

const initialState = {
  all: [],
  fetching: false,
  fetched: false,
  fetchingError: null
};

const fetchAvailabilityOptionsHandler = routine => ({
  [routine.REQUEST]: state => ({
    ...state,
    fetching: true,
    fetched: false
  }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('all', response.items, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

export default createReducer(initialState, {
  ...fetchAvailabilityOptionsHandler(fetchInventoryAvailabilityOptions)
});
